import { t, useI18n } from "@bookingcom/lingojs-react";
import React from "react";
import FlightCardPositionAnnouncement from "./FlightCardPositionAnnouncement.js";
const FlightCardWrapper = ({ index, total, children }) => {
    const i18n = useI18n();
    return (React.createElement(React.Fragment, null,
        React.createElement(FlightCardPositionAnnouncement, { index: index, total: total }),
        React.createElement("div", { id: `flightcard-${index}`, "data-testid": "searchresults_card" },
            React.createElement("div", { role: "group", "aria-label": i18n.trans(t("a11y_flights_search_card_begin")) }, children))));
};
export default FlightCardWrapper;
